import React from 'react';
import css from './css';

interface Props {
  text: string;
  disabled?: boolean;
  updateText: (e: React.ChangeEvent<HTMLTextAreaElement>) => void;
}

const Textarea: React.FC<Props> = ({ text, updateText, disabled }: Props) => (
  <>
    <textarea
      name="text"
      disabled={disabled}
      // @ts-ignore
      className={styles.textarea}
      cols={30}
      rows={3}
      placeholder="Type your note here..."
      value={text}
      onChange={(e) => updateText(e)}
    />
  </>
);

const styles = css({
  textarea: {
    marginBottom: '15px !important', // margin bottom is being overwritten at app4 level
    display: 'block',
    width: '100%',
  },
});

export default Textarea;
